export default function Subsidiaries() {
    return (
        <div>
            <h2>subsidiaries</h2>
        </div>
    )
}
